/**
 * Created by slava on 27/10/17
 */

const ResourceProcessor = {
    calcAlwaysNeed: function () {
        const probablyNeed = ["main", "ui"];
        if (cleverapps.config.debugMode) {
            probablyNeed.push("dev_resources");
        }
        return probablyNeed;
    },

    calcProbablyNeed: function () {
        let probablyNeed = ResourceProcessor.calcAlwaysNeed();

        const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
        probablyNeed.push(isVertical ? "game_background_vertical" : "game_background_horizontal");

        let SceneClass = cleverapps.Plot.onStartup(undefined, true);
        let options = [];
        if (typeof SceneClass === "object" && !(SceneClass instanceof VirtualJson)) {
            options = SceneClass.options;
            SceneClass = SceneClass.scene;
        }

        let nextScene;
        if (SceneClass instanceof VirtualJson) {
            // on localhost scene prefabs are fromSource and have no data before main is loaded - skip scene bundles preloading
            if (SceneClass.resolve().getJson()) {
                nextScene = Prefab.instantiate(SceneClass, { args: options });
            }
        } else {
            nextScene = new SceneClass(options[0], options[1], options[2], options[3], options[4]);
        }

        const sceneComponent = nextScene && ComponentMap.get(nextScene, SceneComponent);
        if (sceneComponent) {
            probablyNeed = probablyNeed.concat(sceneComponent.bundles || [], sceneComponent.listBaseBundles());
        }

        probablyNeed = probablyNeed.filter((name) => bundles[name]);

        return [...new Set(probablyNeed)];
    }
};
